import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["card"]
  
  connect() {
    const color = this.element.dataset.color
    this.element.style.setProperty('--appointment-color', color)
  }
  
  hover() {
    this.element.classList.add('appointment-hover')
  }
  
  unhover() {
    this.element.classList.remove('appointment-hover')
  }
}